import { msg } from "@lingui/core/macro";

export const smsIsRequiredRuleMessages = {
	name: msg({ message: "Phone number is required" }),
	description: msg({ message: "Parker must provide a mobile phone number for SMS reminders when registering" }),
	errors: {
		empty: msg({ message: "Phone number is required" }),
		invalid: msg({ message: "Enter a valid phone number" }),
	},
} as const;
